import {EventBase} from "shared/utilities/Events/EventManager";
import { PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";





export class GetControlOptions extends EventBase {
    ReturnType: PDFControlBaseOptions;

    constructor(public Type:string) {
        super();
    }

    public static GetName() {
        return 'GetControlOptions';
    }
}